import { axiosInstance } from '@common/api/axiosInstance';
import { MinStaySettings } from '@common/api/minstay/types';


const MINSTAY_SETTINGS_API = '/pricingalgorithm/minstay-settings/'

export const getMinStaySettings = async () => {
  const response = await axiosInstance.get<MinStaySettings>(MINSTAY_SETTINGS_API);
  return response.data;
};

export const saveMinStaySettings = async (settings: string) => {
  const response = await axiosInstance.post<MinStaySettings>(
    MINSTAY_SETTINGS_API,
    settings
  );
  return response.data;
};
